import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function TruthSection() {
  return <section className="bg-slate-50 text-slate-800 py-20 px-4" data-id="element-291">
      <div className="max-w-3xl mx-auto" data-id="element-292">
        <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-12 text-center" data-id="element-293">
          LA VERDAD INCÓMODA
        </h2>

        <div className="space-y-8 text-lg md:text-xl leading-relaxed" data-id="element-294">
          <p className="font-bold text-xl" data-id="element-295">
            Escucha esto porque es lo que nadie te ha dicho con claridad:
          </p>

          <div className="bg-white p-6 md:p-8 rounded-xl shadow-lg border-l-8 border-red-500" data-id="element-296">
            <p className="font-extrabold text-2xl text-slate-900" data-id="element-297">
              Si tienes entre 40 y 50 años, tu dolor al despertar no es
              aleatorio. Es predecible. Y es evitable.
            </p>
          </div>

          <p data-id="element-298">Aquí está la mecánica:</p>

          <p data-id="element-299">
            Durante las horas que duermes, tus discos intervertebrales absorben
            líquido. Se hidratan. Se expanden.
          </p>

          <p data-id="element-300">Eso es bueno — es regeneración.</p>

          <p className="font-bold text-red-600 text-2xl" data-id="element-301">
            Pero tiene un costo temporal:
          </p>

          <p data-id="element-302">
            Al despertar, tus discos están en su punto de máxima presión. El
            espacio entre vértebras es mínimo. El nervio ciático tiene menos
            margen de tolerancia que en cualquier otro momento del día.
          </p>

          <p className="font-bold" data-id="element-303">
            Y en ese preciso momento — el más vulnerable de las 24 horas — la
            mayoría de personas hace una de estas tres cosas:
          </p>

          <ul className="space-y-4 font-bold text-slate-900 bg-slate-100 p-6 rounded-lg" data-id="element-304">
            <li className="flex items-start gap-3" data-id="element-305">
              <span className="text-red-500 mt-1" data-id="element-306">→</span>
              <span data-id="element-307">Saltan de la cama de golpe</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-308">
              <span className="text-red-500 mt-1" data-id="element-309">→</span>
              <span data-id="element-310">
                Se sientan y se doblan hacia adelante "para destrabar"
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-311">
              <span className="text-red-500 mt-1" data-id="element-312">→</span>
              <span data-id="element-313">Se estiran fuerte "para que algo truene"</span>
            </li>
          </ul>

          <p data-id="element-314">
            Cada uno de esos movimientos comprime el disco contra el nervio.
          </p>

          <p data-id="element-315">Es como apretar una manguera que ya está al límite.</p>

          <div className="bg-red-50 p-6 rounded-xl border border-red-100 mt-8" data-id="element-316">
            <div className="flex items-center gap-3 mb-4" data-id="element-317">
              <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-318" />
              <p className="font-bold text-xl text-red-700" data-id="element-319">El resultado:</p>
            </div>
            <p className="font-extrabold text-2xl text-red-600" data-id="element-320">
              El nervio se irrita, se inflama, y tienes 16 horas de infierno
              garantizado.
            </p>
          </div>

          <p data-id="element-321">No porque hayas hecho algo "malo".</p>

          <p className="text-2xl font-bold text-slate-900 text-center pt-8" data-id="element-322">
            Sino porque nadie te enseñó el{' '}
            <span className="text-blue-600 underline decoration-4 underline-offset-4" data-id="element-323">
              ángulo correcto para ese momento específico.
            </span>
          </p>
        </div>
      </div>
    </section>;
}